<template>
  <div :class="['ms-form', 'ms-form--narrow', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomInput
          :value="formData.client_name"
          label="Имя клиента"
          :fullWidth="true"
          @change_input="(value) => onChange('client_name', value)"
        />
        <CustomInput
          :value="formData.review_text"
          type="textarea"
          label="Текст отзыва"
          :fullWidth="true"
          @change_input="(value) => onChange('review_text', value)"
        />
        <CustomInput
          :value="formData.review_score"
          type="number"
          :controls="true"
          label="Оценка"
          :fullWidth="true"
          @change_input="(value) => onChange('review_score', value)"
        />
      </div>
      <CustomModalFooter :btn-loading="this.btnLoading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomUploader from "@/components/form/CustomUploader";
import CustomInput from "@/components/form/CustomInput";

export default {
  name: "add-contractor-review",
  components: { CustomModalFooter, CustomUploader, CustomInput },
  props: ["data"],
  data() {
    return {
      btnLoading: false,
      formData: {
        photo: "",
        contractor_id: this.data?.body.contractor_id || "",
        partner_review_id: this.data?.body.partner_review_id || "",
        client_name: this.data?.body.client_name || "",
        review_text: this.data?.body.review_text || "",
        review_score: this.data?.body.review_score || 0,
      },
    };
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.btnLoading = true;
      if (this.formData.photo) {
        this.formData.photo = this.formData.photo[0];
      }
      await this.data?.onSubmit(this.formData);
      this.btnLoading = false;
    },
  },
};
</script>
